import './assets/css/style.css';
import '@style/App.css';
import '@style/Global.css';
import '@style/MultiSelect.css';
import '@style/Toastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { createRoot } from 'react-dom/client';
import Meta from '@com/Meta';
import ScrollToTop from '@com/ScrollToTop';
import StateProvider from './state';
import loadable from '@loadable/component';

const App = loadable(() => import('./App'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 2,
      retryDelay: 5 * 1000,
      refetchOnMount: true,
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <HelmetProvider>
    <Meta title={process.env.REACT_APP_TITLE} />
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <StateProvider>
          <ToastContainer
            closeOnClick
            draggable
            pauseOnHover
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            pauseOnFocusLoss={false}
            position="top-right"
            rtl={false}
            theme="dark"
          />
          <ScrollToTop />
          <App />
        </StateProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </HelmetProvider>
);
